'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
require('../Accordion/Accordion.js');
require('../AlertBanner/AlertBanner.js');
require('../MediaList/MediaList.js');
require('../MediaList/MediaListItem/MediaListItem.js');
require('../MediaList/MediaListItemImage/MediaListItemImage.js');
require('../MediaList/MediaListItemPodcast/MediaListItemPodcast.js');
require('../MediaList/MediaListItemVideo/MediaListItemVideo.js');
var CardCarousel = require('../CardCarousel/CardCarousel.js');
require('./../../external/classnames/index.js');
require('../../sections/Alert/Alert.js');
require('../../sections/Article/Article.js');
require('../../sections/ArticleInfoBlock/ArticleInfoBlock.js');
require('../../sections/Banner/Banner.js');
require('../../sections/BreadCrumbs/BreadCrumbs.js');
require('../../sections/ErrorPage/ErrorPage.js');
require('../../sections/FeatureCarousel/FeatureCarousel.js');
require('../../sections/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../../sections/FeaturedMarquee/FeaturedMarquee.js');
require('../../sections/NewsletterSubscription/NewsletterSubscription.js');
require('../../sections/OpenPositions/OpenPositions.js');
require('../../sections/OurTeam/OurTeam.js');
require('../../sections/PageHeader/PageHeader.js');
require('../../sections/Pagination/Pagination.js');
require('../../sections/PaginationContainer/PaginationContainer.js');
require('../../sections/PanelGroup/PanelGroup.js');
require('../../sections/PanelGroup/Panel/Panel.js');
require('../../sections/PodcastCarousel/PodcastCarousel.js');
require('../../sections/SecondaryNav/SecondaryNav.js');
require('../../sections/Section/Section.js');
require('../../sections/Section/SectionHeader/SectionHeader.js');
require('../../sections/SplitBanner/SplitBanner.js');
require('../../sections/SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../../sections/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../../sections/SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../../sections/SplitBanner/SplitBannerContact/SplitBannerContact.js');
require('../ContentIntroduction/ContentIntroduction.js');
require('../ContentTitle/ContentTitle.js');
require('../Gallery/Gallery.js');
require('../SideBar/SideBar.js');
require('../SideBar/ContactsBlock/ContactsBlock.js');
require('../../utilities/GatsbyLink/index.js');
require('../SideBar/ListenBlock/ListenBlock.js');
require('../SideBar/MediaContactBlock/MediaContactBlock.js');
require('../SideBar/RssBlock/RssBlock.js');
require('../SideBar/SearchBlock/SearchBlock.js');
require('../SideBar/SocialBlock/SocialBlock.js');
require('../SideBar/TopicBlock/TopicBlock.js');
require('../ScrollToTop/ScrollToTop.js');
var Card = require('../../composites/Card/Card.js');
var CardBody = require('../../composites/Card/CardBody/CardBody.js');
require('../../composites/Card/CardImage/CardImage.js');
require('../../composites/Card/CardText/CardText.js');
var CardTitle = require('../../composites/Card/CardTitle/CardTitle.js');
require('../../composites/Carousel/Carousel.js');
require('../../composites/Carousel/CarouselControl/CarouselControl.js');
require('../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');
require('../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');
var CarouselItem = require('../../composites/Carousel/CarouselItem/CarouselItem.js');
require('../../composites/Carousel/CarouselInner/CarouselInner.js');
require('../../composites/EventCard/EventCard.js');
require('../../composites/EventCard/EventGrid/EventGrid.js');
var Modal = require('../../composites/Modal/Modal.js');
var ModalBody = require('../../composites/Modal/ModalBody/ModalBody.js');
require('../../composites/Modal/ModalFooter/ModalFooter.js');
require('../../composites/Modal/ModalHeader/ModalHeader.js');
require('../../composites/SearchBar/SearchBar.js');
var Video = require('../../composites/Video/Video.js');
var useMobileBool = require('../../utilities/hooks/useMobileBool.js');
var arrow_right_inline = require('../../assets/svg/arrow_right.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var renderVideoCards = function renderVideoCards(videos) {
  return videos.map(function (_ref, index) {
    var thumbnail_image = _ref.thumbnail_image,
      thumbnail_quality = _ref.thumbnail_quality,
      title = _ref.title,
      video_duration = _ref.video_duration,
      video_id = _ref.video_id,
      video_source = _ref.video_source,
      _ref$youtube_video = _ref.youtube_video,
      youtube_video = _ref$youtube_video === void 0 ? true : _ref$youtube_video;
    var _useState = React.useState(false),
      _useState2 = slicedToArray.default(_useState, 2),
      modalIsOpen = _useState2[0],
      setModalIsOpen = _useState2[1];
    var videoFeatureImageSrc = youtube_video ? "https://img.youtube.com/vi/".concat(video_id, "/").concat(thumbnail_quality !== null && thumbnail_quality !== void 0 ? thumbnail_quality : 'sddefault', ".jpg") : thumbnail_image;
    var videoSrc = youtube_video ? "https://youtube.com/embed/".concat(video_id, "?rel=0&controls=0&modestBranding=1") : video_source;
    return /*#__PURE__*/React__default.default.createElement(CarouselItem.CarouselItem, {
      key: "top-videos-".concat(video_id),
      className: "lanl-card-carousel-item",
      itemId: index,
      card: true
    }, /*#__PURE__*/React__default.default.createElement(Card.Card, {
      key: video_id
    }, /*#__PURE__*/React__default.default.createElement(Video.Video, {
      videoFeatureImageSrc: videoFeatureImageSrc,
      time: video_duration,
      onClickCB: function onClickCB() {
        return setModalIsOpen(true);
      },
      className: "lanl-video-carousel-item-video"
    }), /*#__PURE__*/React__default.default.createElement(CardBody.CardBody, null, /*#__PURE__*/React__default.default.createElement(CardTitle.CardTitle, null, title), /*#__PURE__*/React__default.default.createElement("div", {
      className: "lanl-video-carousel-item-link",
      onClick: function onClick(e) {
        e.preventDefault();
        setModalIsOpen(true);
      }
    }, /*#__PURE__*/React__default.default.createElement("span", {
      className: "lanl-link"
    }, "Watch Now ", /*#__PURE__*/React__default.default.createElement("span", {
      className: "sr-only"
    }, "about: ", title), /*#__PURE__*/React__default.default.createElement(arrow_right_inline.default, {
      className: "link-arrow"
    }))))), /*#__PURE__*/React__default.default.createElement(Modal.Modal, {
      isOpen: modalIsOpen,
      toggle: function toggle() {
        return setModalIsOpen(false);
      },
      size: useMobileBool.useMobileBool() ? 'fluid' : 'xl',
      centered: true
    }, /*#__PURE__*/React__default.default.createElement(ModalBody.ModalBody, null, /*#__PURE__*/React__default.default.createElement("iframe", {
      title: title,
      src: videoSrc,
      className: "video-iframe"
    }))));
  });
};
var VideoCardCarousel = function VideoCardCarousel(_ref2) {
  var videos = _ref2.videos,
    controlsColor = _ref2.controlsColor;
  return /*#__PURE__*/React__default.default.createElement(CardCarousel.CardCarousel, {
    length: videos.length,
    className: "video-card-carousel",
    controlsColor: controlsColor
  }, renderVideoCards(videos));
};
VideoCardCarousel.defaultProps = {
  controlsColor: 'white',
  videos: []
};
VideoCardCarousel.propTypes = {
  controlsColor: PropTypes__default.default.oneOf(['white', 'standard']),
  videos: PropTypes__default.default.array
};

exports.VideoCardCarousel = VideoCardCarousel;
exports.default = VideoCardCarousel;
//# sourceMappingURL=VideoCardCarousel.js.map
